package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.forms.MonthDropdown
import io.horion.cv.components.forms.YearDropdown
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun DateSelector(
    label: String,
    month: String,
    year: String,
    onMonthChange: (String) -> Unit,
    onYearChange: (String) -> Unit,
    disabled: Boolean = false,
    modifier: Modifier = Modifier,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val labelColor = if (isDark) Colors.White else Colors.Primary

    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.Start
    ) {
        SpanText(
            text = label,
            modifier = Modifier
                .fontSize(16.px)
                .color(labelColor)
                .margin(bottom = 8.px)
                .fontFamily(INTER)
                .fontWeight(FontWeight.Light)
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .minWidth(0.px),
            horizontalArrangement = Arrangement.spacedBy(15.px)
        ) {
            MonthDropdown(
                selectedMonth = month,
                onMonthChange = onMonthChange,
                disabled = disabled,
                modifier = Modifier
                    .weight(1f)
                    .minWidth(0.px)
            )

            YearDropdown(
                selectedYear = year,
                onYearChange = onYearChange,
                disabled = disabled,
                modifier = Modifier
                    .weight(1f)
                    .minWidth(0.px)
            )
        }
    }
}
